export const LOADING_DISCIPLINARY_MEASUREMENT = "LOADING_DISCIPLINARY_MEASUREMENT";
export const SAVE_LOADING_DISCIPLINARY_MEASUREMENT = "SAVE_LOADING_DISCIPLINARY_MEASUREMENT";
export const GET_DISCIPLINARY_MEASUREMENT = "GET_DISCIPLINARY_MEASUREMENT";
export const FORM_FAIL = "FORM_FAIL";
export const DISCIPLINARY_MEASUREMENT_FAIL = "DISCIPLINARY_MEASUREMENT_FAIL";

